export default __webpack_public_path__ + "static/media/46.ab6e12d9.gif";